/* ECI CRO CUSTOM CODE */
var RecipeD2 = {
    recipechanges: function(){
        eciATC = document.getElementsByClassName('product-form__buttons');
        eciATC[0].classList.add("eci-product-form__buttons");
        setTimeout(function(){
            eciCheckTop = document.getElementsByClassName('product-form__buttons')[0].offsetTop;
        },100);
    },
    check_if_atc_is_visible: function(){
        eciCheckTop = document.getElementsByClassName('product-form__buttons')[0].offsetTop;
        eciATC = document.getElementsByClassName('product-form__buttons');
        eciATC[0].setAttribute("id", "eci_sticky_btn");
        window.onscroll = function() {myFunction();};

        function myFunction() {
          if (document.body.scrollTop > eciCheckTop || document.documentElement.scrollTop > eciCheckTop) { 
              document.getElementById("eci_sticky_btn").classList.remove('eci-product-form__buttons');
          } else { 
            document.getElementById("eci_sticky_btn").classList.add('eci-product-form__buttons');
          }
        }
    },
    init: function(){
        var ob = this;
        ob.recipechanges();
        ob.check_if_atc_is_visible();
    }
}.init();
